import React from 'react';
import type { IconProps } from './IconPlus';

// Caret (dropdown indicator)
export const IconCaret: React.FC<IconProps> = ({ size = 12, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size / 2} viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M1 1L6 5L11 1" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);
